// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6962) return "static/css/6962.ce6db998c9021a6b041a.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + "4f767f2564a62b1968c8" + ".chunk.css";
};